module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/insurance-details/insurance-details-grid/insurance-details-grid.component.css
// module id = ./src/app/hrms/payroll/insurance-details/insurance-details-grid/insurance-details-grid.component.css
// module chunks = main